import { render, staticRenderFns } from "./WalkingPenguin.vue?vue&type=template&id=0ce57bbc&scoped=true&"
import script from "./WalkingPenguin.vue?vue&type=script&lang=js&"
export * from "./WalkingPenguin.vue?vue&type=script&lang=js&"
import style0 from "./WalkingPenguin.vue?vue&type=style&index=0&id=0ce57bbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce57bbc",
  null
  
)

export default component.exports